import React from 'react';
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { DatePicker, Button } from 'antd';
import './index.scss';
import TextArea from '../../../../components/forms/BuilderTextArea';
import DescriptionSuggestion from '../DescriptionSuggestion';
import dayjs from 'dayjs';

const EducationStep = (props) => {
  const { params, onChange } = props;
  const education = params.education || [];

  const onContinueClick = () => {
    props.onContinueClick && props.onContinueClick();
  };
  const onBackClick = () => {
    props.onBackClick && props.onBackClick();
  };

  const handleFieldChange = (idx, field, value) => {
    const updated = education.map((ed, i) =>
      i === idx ? { ...ed, [field]: value } : ed
    );
    onChange('education', updated);
  };

  const handleDateChange = (idx, field, date) => {
    if (!date) {
      handleFieldChange(idx, field, { month: '', year: '' });
      return;
    }
    handleFieldChange(idx, field, {
      month: parseInt(date.format('MM')),
      year: parseInt(date.format('YYYY')),
    });
  };

  const addEducation = () => {
    onChange('education', [
      ...education,
      {
        universityName: '',
        degreeName: '',
        courseName: '',
        startDate: { month: '', year: '' },
        endDate: { month: '', year: '' },
        location: '',
      },
    ]);
  };

  const removeEducation = (idx) => {
    onChange('education', education.filter((_, i) => i !== idx));
  };

  const generateSuggestionKey = (degreeName, universityName) => {
    return `edu_${degreeName || 'untitled'}_${universityName || 'unknown'}`.replace(/\s+/g, '_').toLowerCase();
  };

  const handleAddSuggestion = (idx, suggestion) => {
    handleFieldChange(idx, 'description', suggestion);
  };

  return (
    <div className="step education-step">
      <div className="step-inner-content">
      <div className="step-header">
        <h2>Education</h2>
        <p>Add the name of your school, where it is located, what degree you obtained, your field of study, and your graduation year.</p>
      </div>
      {(education.length === 0 ? [] : education).map((ed, idx) => (
        <div className="job-card" key={idx}>
          <div className="job-card-header">
            <span className="job-title">{ed.universityName || 'Untitled'}</span>
            <span className="job-card-actions">
              <button className="job-card-delete" title="Delete job" onClick={() => removeEducation(idx)}>🗑️</button>
            </span>
          </div>
          <div className="job-fields">
            <div className="row">
              <div className="field">
                <label>Institution</label>
                <input
                  type="text"
                  placeholder="Harvard"
                  value={ed.universityName || ''}
                  onChange={e => handleFieldChange(idx, 'universityName', e.target.value)}
                />
              </div>
              <div className="field">
                <label>Degree</label>
                <input
                  type="text"
                  placeholder="Bachelor's Degree in Physics"
                  value={ed.degreeName || ''}
                  onChange={e => handleFieldChange(idx, 'degreeName', e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="field">
                <label>Field of Study</label>
                <input
                  type="text"
                  placeholder="Physics"
                  value={ed.courseName || ''}
                  onChange={e => handleFieldChange(idx, 'courseName', e.target.value)}
                />
              </div>
              <div className="field">
                <label>Start date</label>
                <DatePicker
                  style={{ width: '100%' }}
                  picker="month"
                  placeholder="Jan 2016"
                  format="MM/YYYY"
                  value={ed.startDate && ed.startDate.month && ed.startDate.year ? dayjs(new Date(ed.startDate.year, ed.startDate.month)) : null}
                  onChange={date => handleDateChange(idx, 'startDate', date)}
                />
              </div>
              <div className="field">
                <label>End date</label>
                <DatePicker
                  style={{ width: '100%' }}
                  picker="month"
                  placeholder="Feb 2019"
                  format="MM/YYYY"
                  value={ed.endDate && ed.endDate.month && ed.endDate.year ? dayjs(new Date(ed.endDate.year, ed.endDate.month)) : null}
                  onChange={date => handleDateChange(idx, 'endDate', date)}
                />
              </div>
              <div className="field">
                <label>Location</label>
                <input
                  type="text"
                  placeholder="Washington, D.C."
                  value={ed.location || ''}
                  onChange={e => handleFieldChange(idx, 'location', e.target.value)}
                />
              </div>
            </div>
            <div className="row rich-row">
              <div className="field rich-field">
                <div className="rich-toolbar"></div>
                <div className="description-wrapper">
                  <TextArea
                    className="job-description"
                    rows={4}
                    placeholder="Graduated with honors, receiving the John A. Paulson Prize for Excellence in Physics."
                    value={ed.description || ''}
                    onChange={e => handleFieldChange(idx, 'description', e)}
                  />
                  <DescriptionSuggestion
                    education={ed}
                    flow="education"
                    selector={generateSuggestionKey(ed.degreeName, ed.universityName)}
                    resumeData={params}
                    onAdd={suggestion => handleAddSuggestion(idx, suggestion)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      <div style={{ marginBottom: 24 }}>
        <button className="add-object-btn" onClick={addEducation} style={{ width: '100%' }}>+ Add education</button>
      </div>
      </div>
      <div className="step-footer">
        <button className="back-btn" onClick={onBackClick}>&larr; Back</button>
        <Button loading={props.formLoading} className="next-btn" onClick={onContinueClick}>Next <span className="arrow">&rarr;</span></Button>
      </div>
    </div>
  );
};

export default EducationStep;
